import React, { isValidElement } from 'react'
import { AccordionSummary, Grid } from '@mui/material'
import Action from 'components/action/Action'
import { isUndefined } from 'lodash'
import PropTypes from 'prop-types'
import { mainBlue } from 'utils/constants/ColorTheme'

const AccordionTitle = ({
    title = '',
    subTitle = '',
    subtitleSize = 2,
    color = mainBlue,
    fontColor = 'white',
    actions = [],
}) => {
    const filteredActions = actions.filter(a => a.displayed || isUndefined(a.displayed))
    return (
        <AccordionSummary color={color} fontColor={fontColor}>
            <Grid container size={12} spacing={2} alignItems='center' sx={{ width: '100%' }}>
                <Grid size='grow'>
                    {isValidElement(title) ? title : (<span style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>{title}</span>)}
                </Grid>
                {!!subTitle && (
                    <Grid size={subTitle ? subtitleSize : 'auto'}>
                        {isValidElement(subTitle) ? subTitle : (<span style={{ fontSize: '1.4rem' }}>{subTitle}</span>)}
                    </Grid>
                )}
                {filteredActions.length > 0 && (
                    <Grid container size='auto' spacing={0.5} onClick={e => e.stopPropagation()}>
                        {filteredActions.map(action => (
                            <Grid key={actions.indexOf(action)} size='auto'>
                                {isValidElement(action) ? action : (<Action {...action} />)}
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Grid>
        </AccordionSummary>
    )
}

AccordionTitle.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitleSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    actions: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.shape({
            icon: PropTypes.string,
            tooltip: PropTypes.string,
            onClick: PropTypes.func,
            color: PropTypes.string,
            displayed: PropTypes.bool,
            'data-cy': PropTypes.string,
        }),
    ])),
    color: PropTypes.string,
    fontColor: PropTypes.string,
}

export {
    AccordionTitle,
}